import { motion } from "framer-motion";
import { Zap, Timer, Users } from "lucide-react";

const STATS = [
  { icon: Zap, value: "3X", label: "Improved response speed", sub: "From hours to seconds", accent: "text-[#00F0FF]", glow: "glow-cyan" },
  { icon: Timer, value: "40+", label: "Hours saved per month", sub: "Across your team", accent: "text-[#007AFF]", glow: "glow-blue" },
  { icon: Users, value: "∞", label: "Leads handled without extra staff", sub: "System scales for you", accent: "text-[#8B5CF6]", glow: "glow-violet" },
];

export default function ProofSection() {
  return (
    <section id="proof" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#8B5CF6] mb-4" data-testid="proof-kicker">Proof</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium text-white leading-tight" data-testid="proof-heading">
            Real outcomes, not just promises.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`glass-card tilt-card p-8 relative overflow-hidden ${s.glow}`}
              data-testid={`proof-card-${i}`}
            >
              <div className="absolute top-0 right-0 w-32 h-32 rounded-full bg-white/[0.02] blur-3xl" />
              <s.icon className={`${s.accent} mb-6`} size={26} />
              <div className={`font-display text-6xl font-semibold ${s.accent}`}>{s.value}</div>
              <div className="mt-4 text-white text-lg font-medium">{s.label}</div>
              <div className="text-white/50 text-sm mt-1">{s.sub}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
